<app-navbar />

<div class="container-fluid">
  <!-- Filtros -->
  <div class="card shadow-sm filtros-modernas border-0 mb-4">
    <div class="card-header d-flex align-items-center rounded-top">
      <i class="fas fa-rotate fs-5 me-2 text-white"></i>
      <h2 class="fw-bold">Recadastro</h2>
    </div>
    <div class="card-body">
      <!-- Linha com botão de filtro à esquerda e controles de paginação/itens por página à direita -->
      <div class="row mt-3" *ngIf="!erro">
        <div class="top-controls compact-controls d-flex flex-wrap align-items-center justify-content-between">
          <!-- Botão Filtrar -->
          <button class="btn btn-info btn-sm me-2" type="button" (click)="toggleFiltros()">
            <i class="fas fa-filter me-1"></i> Filtrar
          </button>

          <!-- Período -->
          <div class="d-flex align-items-center gap-2 me-3">
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataInicio" />
            <span>até</span>
            <input class="form-control form-control-sm period-input" type="date" [(ngModel)]="filtroDataFim"
              (change)="onFiltroDataFimChange()" />
            <button class="btn btn-primary ms-2" (click)="aplicarFiltro()">
              <i class="fas fa-sync-alt me-1"></i> Recarregar
            </button>
          </div>

          <!-- Itens por página + Paginação -->
          <div class="d-flex align-items-center gap-2 ms-auto">
            <label class="mb-0 small">Itens:</label>
            <select id="tamanhoPaginaSelect" class="form-select form-select-sm" [(ngModel)]="tamanhoPagina"
              (ngModelChange)="alterarTamanhoPagina($event)">
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
              <option [value]="100">100</option>
            </select>

            <span class="page-info small">
              Página {{paginaAtual}} de {{totalPaginas}} ({{totalItens}} itens)
            </span>

            <!-- Botões -->
            <button class="btn btn-outline-secondary btn-sm" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
              <i class="fas fa-chevron-left"></i>
            </button>
            <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()"
              [disabled]="paginaAtual >= totalPaginas">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="row mt-2" *ngIf="showFiltros">
        <!-- <div class="col-md-3">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="filtroStatus">
            <option value="">Todos</option>
            <option value="EmAndamento">EmAndamento</option>
            <option value="Concluida">Concluido</option>
            <option value="Retornar">Retornar</option>
            <option value="Negada">Negado</option>
            <option value="Validado">Validado</option>
            <option value="Invalido">Invalido</option>
          </select>
        </div> -->
        <!-- <div class="col-md-3">
          <label class="form-label">Matrícula</label>
          <input type="text" class="form-control" [(ngModel)]="filtroMatricula" placeholder="Matrícula do consumidor" />
        </div> -->
        <div class="col-md-3">
          <label class="form-label">Nº Vistoria</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNumeroVistoria" placeholder="Nº Vistoria" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Nome Consumidor</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNomeConsumidor" placeholder="Nome do consumidor" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CPF</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCpf" placeholder="CPF" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CNPJ</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCnpj" placeholder="CNPJ" />
        </div>
        <div class="col-md-3">
          <label class="form-label">CEP</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCep" placeholder="CEP" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Número</label>
          <input type="text" class="form-control" [(ngModel)]="filtroNumero" placeholder="Número (logradouro)" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Logradouro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroLogradouro" placeholder="Logradouro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Bairro</label>
          <input type="text" class="form-control" [(ngModel)]="filtroBairro" placeholder="Bairro" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Cidade</label>
          <input type="text" class="form-control" [(ngModel)]="filtroCidade" placeholder="Cidade" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Estado</label>
          <input type="text" class="form-control" [(ngModel)]="filtroEstado" placeholder="Estado" />
        </div>
        <div class="col-12 mt-2 d-flex gap-2">
          <button class="btn btn-primary" (click)="aplicarFiltro()">Aplicar filtros</button>
          <button class="btn btn-secondary" (click)="resetarERecarregar()">Limpar e Recarregar</button>
        </div>
      </div>
    </div>
  </div>

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Processando, por favor aguarde... </p>
  </ngx-spinner>

  <div *ngIf="erro" class="alert alert-danger d-flex align-items-center gap-2">
    <i class="bi bi-exclamation-triangle-fill"></i> {{ erro }}
  </div>
  <div
    *ngIf="!carregando && recadastrosFiltrados.length === 0 && (filtroUsuarioId || (!filtroUsuarioId && recadastros.length === 0))"
    class="alert alert-warning d-flex align-items-center gap-2">
    <i class="bi bi-folder-x"></i>
    <span *ngIf="filtroUsuarioId">Nenhum recadastro encontrado no período.</span>
    <span *ngIf="!filtroUsuarioId">Nenhum recadastro encontrado.</span>
  </div>

  <!-- Tabela de recadastros -->
  <div class="table-responsive" *ngIf="recadastrosFiltrados.length > 0">
    <table class="table table-bordered table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>Data</th>
          <th>N° Vistoria</th>
          <th>Nome Consumidor</th>
          <th>CPF/CNPJ</th>
          <th>Telefone</th>
          <th>Endereço</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let recadastro of recadastrosFiltrados">
          <td>
            <span class="text-primary fw-bold">
              {{ recadastro.dataRecadastramento | date: 'dd/MM/yyyy' }}
            </span>
          </td>
          <td>
            <span class="badge bg-gradient-info">
              {{ recadastro.numeroOS || '-' }}
            </span>
          </td>
          <td>
            <span class="fw-bold text-dark">
              <i class="bi bi-person-circle me-1 text-info"></i>
              {{ recadastro.nomeConsumidor }}
            </span>
          </td>
          <td>
            <span class="badge bg-light text-dark badge-campo-doc d-flex align-items-center gap-1">
              <i class="bi bi-card-text text-primary"></i>
              {{ recadastro.cpf ? (recadastro.cpf.length === 11 ? maskCpf(recadastro.cpf) : maskCnpj(recadastro.cpf)) :
              '-' }}
            </span>
          </td>
          <td>
            <span class="badge bg-light text-dark badge-campo-tel d-flex align-items-center gap-1">
              <i class="bi bi-telephone text-success"></i>
              {{ maskTelefone(recadastro.telefone) }}
            </span>
          </td>
          <td>
            <span *ngIf="recadastro.endereco" class="text-secondary" style="font-size:0.97rem;">
              {{ recadastro.endereco.logradouro }}, {{ recadastro.endereco.bairro }}, {{ recadastro.endereco.cidade }} -
              {{ recadastro.endereco.estado }}
            </span>
            <span *ngIf="!recadastro.endereco" class="text-muted">-</span>
          </td>
          <td>
            <button class="btn btn-outline-primary btn-xs px-2 py-1" style="font-size:0.95rem;"
              (click)="verDetalhes(recadastro)">
              <i class="bi bi-eye me-1"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Controles de Paginação -->
  <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="totalPaginas > 1">
    <!-- Informações sobre registros -->
    <div class="text-muted">
      <small>
        Mostrando {{((paginaAtual - 1) * tamanhoPagina) + 1}} -
        {{Math.min(paginaAtual * tamanhoPagina, totalItens)}} de {{totalItens}} registros
      </small>
    </div>

    <!-- Controles de navegação -->
    <nav aria-label="Navegação de páginas">
      <ul class="pagination pagination-sm mb-0">
        <!-- Primeira página -->
        <li class="page-item" [class.disabled]="paginaAtual === 1">
          <button class="page-link" (click)="irParaPagina(1)" [disabled]="paginaAtual === 1">
            <i class="bi bi-chevron-bar-left"></i>
          </button>
        </li>

        <!-- Página anterior -->
        <li class="page-item" [class.disabled]="paginaAtual === 1">
          <button class="page-link" (click)="paginaAnterior()" [disabled]="paginaAtual === 1">
            <i class="bi bi-chevron-left"></i>
          </button>
        </li>

        <!-- Páginas numeradas -->
        <li class="page-item" *ngFor="let pagina of obterPaginas()" [class.active]="pagina === paginaAtual">
          <button class="page-link" (click)="irParaPagina(pagina)">
            {{pagina}}
          </button>
        </li>

        <!-- Próxima página -->
        <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
          <button class="page-link" (click)="proximaPagina()" [disabled]="paginaAtual === totalPaginas">
            <i class="bi bi-chevron-right"></i>
          </button>
        </li>

        <!-- Última página -->
        <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
          <button class="page-link" (click)="irParaPagina(totalPaginas)" [disabled]="paginaAtual === totalPaginas">
            <i class="bi bi-chevron-bar-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</div>

<!-- Spinner de carregamento -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
  <p style="color: white"> Processando, por favor aguarde... </p>
</ngx-spinner>

<!-- Modal de detalhes do recadastro -->
<div class="modal fade show" tabindex="-1"
  [ngStyle]="{display: recadastroDetalhes ? 'flex' : 'none', background: 'rgba(0,0,0,0.4)', alignItems: 'center', justifyContent: 'center'}"
  *ngIf="recadastroDetalhes">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content" #conteudoModal>
      <div class="modal-header bg-gradient-info text-white">
        <h5 class="modal-title">
          <i class="bi bi-file-earmark-text me-2"></i>
          Detalhes do Recadastro
        </h5>
        <button type="button" class="btn-close" (click)="fecharModalDetalhes()"></button>
      </div>
      <div class="modal-body">
        <form class="form px-2 py-2">
          <fieldset>
            <legend class="mb-2">Dados do Consumidor</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Nome do Consumidor</label>
                <input type="text" [value]="recadastroDetalhes.nomeConsumidor || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>CPF</label>
                <input type="text" [value]="maskCpf(recadastroDetalhes.cpf)" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Email</label>
                <input type="text" [value]="recadastroDetalhes.email || '-'" readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-4 mb-2">
              <div>
                <label>Matrícula</label>
                <input type="text" [value]="recadastroDetalhes.matricula || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Telefone</label>
                <input type="text" [value]="maskTelefone(recadastroDetalhes.telefone)" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Ciclo de Leitura</label>
                <input type="text" [value]="recadastroDetalhes.cicloDeLeitura || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Número Imóvel</label>
                <input type="text" [value]="recadastroDetalhes.numeroImovel || '-'" readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-4 mb-2">
              <div>
                <label>Referência</label>
                <input type="text" [value]="recadastroDetalhes.referencia || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Data Recadastro</label>
                <input type="text" [value]="recadastroDetalhes.dataHoraInicio | date: 'dd/MM/yyyy HH:mm'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Loja/Loc</label>
                <input type="text" [value]="recadastroDetalhes.lojLoc || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Concessão Expediente</label>
                <input type="text" [value]="recadastroDetalhes.concessaoExpediente || '-'" readonly
                  class="campo-readonly" />
              </div>
            </div>

            <div class="grid-3 mb-2">
              <div>
                <label>Sistema de Abastecimento</label>
                <input type="text" [value]="recadastroDetalhes.sistemaAbastecimento || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Tipo de Abastecimento</label>
                <input type="text" [value]="recadastroDetalhes.tipoAbastecimento || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Tipo Utilização</label>
                <input type="text" [value]="recadastroDetalhes.tipoUtilizacao || '-'" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset *ngIf="recadastroDetalhes.possuiDebito">
            <div>
              <label>Possui Débito</label>
              <input type="text" [value]="recadastroDetalhes.possuiDebito ? 'Sim' : 'Não'" readonly
                class="campo-readonly" />
            </div>
            <div class="grid-2 mb-2" *ngIf="recadastroDetalhes.valorDebito || recadastroDetalhes.dataInicioDebito">
              <div *ngIf="recadastroDetalhes.valorDebito">
                <label>Valor do Débito</label>
                <input type="text" [value]="recadastroDetalhes.valorDebito | currency:'BRL':'symbol':'1.2-2'" readonly
                  class="campo-readonly" />
              </div>
              <div *ngIf="recadastroDetalhes.dataInicioDebito">
                <label>Data Início Débito</label>
                <input type="text" [value]="recadastroDetalhes.dataInicioDebito | date:'dd/MM/yyyy'" readonly
                  class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Endereço</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>CEP</label>
                <input type="text" [value]="recadastroDetalhes.endereco?.cep || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Logradouro</label>
                <input type="text" [value]="recadastroDetalhes.endereco?.logradouro || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Complemento</label>
                <input type="text" [value]="recadastroDetalhes.endereco?.complemento || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Bairro</label>
                <input type="text" [value]="recadastroDetalhes.endereco?.bairro || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Localidade</label>
                <input type="text" [value]="recadastroDetalhes.endereco?.cidade || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>UF</label>
                <input type="text" [value]="recadastroDetalhes.endereco?.estado || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Número</label>
                <input type="text" [value]="recadastroDetalhes.endereco?.numero || '-'" readonly
                  class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset
            *ngIf="recadastroDetalhes.numeroHidrometro || recadastroDetalhes.marcacao || recadastroDetalhes.seloReloj || recadastroDetalhes.seloVirola || recadastroDetalhes.ramal || recadastroDetalhes.direto !== undefined || recadastroDetalhes.haCisterna !== undefined || recadastroDetalhes.haReservatorioElevado !== undefined || recadastroDetalhes.tipoEconomia || recadastroDetalhes.haPiscina !== undefined">
            <legend class="mb-2">ÁGUA</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Nº Hidrômetro</label>
                <input type="text" [value]="recadastroDetalhes.numeroHidrometro || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Marcação</label>
                <input type="text" [value]="recadastroDetalhes.marcacao || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Selo Reloj.</label>
                <input type="text" [value]="recadastroDetalhes.seloReloj || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Selo Virola</label>
                <input type="text" [value]="recadastroDetalhes.seloVirola || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Ramal</label>
                <input type="text" [value]="recadastroDetalhes.ramal || '-'" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Direto</label>
                <input type="text"
                  [value]="recadastroDetalhes.direto === undefined ? '-' : (recadastroDetalhes.direto ? 'Sim' : 'Não')"
                  readonly class="campo-readonly" />
              </div>
            </div>

            <div class="grid-1 mb-2">

              <fieldset *ngIf="recadastroDetalhes.haCisterna !== undefined">
                <h4>Cisterna</h4>
                <label>Há cisterna?</label>
                <input type="text" [value]="recadastroDetalhes.haCisterna ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div *ngIf="recadastroDetalhes.haCisterna && recadastroDetalhes.capacidadeCisternaInformada">
                  <label>Capacidade Informada</label>
                  <input type="text" [value]="recadastroDetalhes.capacidadeCisternaInformada" readonly
                    class="campo-readonly" />
                </div>
                <div *ngIf="recadastroDetalhes.haCisterna && recadastroDetalhes.observacoesCisterna">
                  <label>Observações</label>
                  <textarea readonly class="campo-readonly"
                    rows="2">{{ recadastroDetalhes.observacoesCisterna }}</textarea>
                </div>
              </fieldset>

              <fieldset *ngIf="recadastroDetalhes.haReservatorioElevado !== undefined">
                <h4>Reservatório Elevado</h4>
                <label>Há Reservatórios Elevados?</label>
                <input type="text" [value]="recadastroDetalhes.haReservatorioElevado ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div
                  *ngIf="recadastroDetalhes.haReservatorioElevado && recadastroDetalhes.capacidadeReservatorioElevadoInformada">
                  <label>Capacidade Informada</label>
                  <input type="text" [value]="recadastroDetalhes.capacidadeReservatorioElevadoInformada" readonly
                    class="campo-readonly" />
                </div>
                <div
                  *ngIf="recadastroDetalhes.haReservatorioElevado && recadastroDetalhes.observacoesReservatorioElevado">
                  <label>Observações</label>
                  <textarea readonly class="campo-readonly"
                    rows="2">{{ recadastroDetalhes.observacoesReservatorioElevado }}</textarea>
                </div>
              </fieldset>

              <fieldset *ngIf="recadastroDetalhes.haPiscina !== undefined">
                <h4>Piscina</h4>
                <label>Existe Piscina?</label>
                <input type="text" [value]="recadastroDetalhes.haPiscina ? 'Sim' : 'Não'" readonly
                  class="campo-readonly" />
                <div *ngIf="recadastroDetalhes.haPiscina && recadastroDetalhes.dimensoesPiscina">
                  <label>Dimensões:</label>
                  <input type="text" [value]="recadastroDetalhes.dimensoesPiscina" readonly class="campo-readonly" />
                </div>
              </fieldset>
            </div>
          </fieldset>


          <fieldset *ngIf="recadastroDetalhes.tipoEconomia">
            <legend class="mb-2">Economias</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Tipos de Economias</label>
                <input type="text" [value]="recadastroDetalhes.tipoEconomia || '-'" readonly class="campo-readonly" />
              </div>
              <div *ngIf="recadastroDetalhes.dUnica">
                <label>Sub Categoria</label>
                <input type="text" [value]="recadastroDetalhes.dUnica" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Número de Economias</label>
                <input type="text" [value]="recadastroDetalhes.numeroDeEconomias || '-'" readonly
                  class="campo-readonly" />
              </div>
            </div>

            <!-- DOMICILIAR -->
            <div class="grid-3 mb-2"
              *ngIf="recadastroDetalhes.tipoEconomia === 'DOMICILIAR' && (recadastroDetalhes.numeroDeQuartos || recadastroDetalhes.numeroDeSalas || recadastroDetalhes.numeroWcPav)">
              <div *ngIf="recadastroDetalhes.numeroDeQuartos">
                <label>Nº Quartos</label>
                <input type="text" [value]="recadastroDetalhes.numeroDeQuartos" readonly class="campo-readonly" />
              </div>
              <div *ngIf="recadastroDetalhes.numeroDeSalas">
                <label>Nº Salas</label>
                <input type="text" [value]="recadastroDetalhes.numeroDeSalas" readonly class="campo-readonly" />
              </div>
              <div *ngIf="recadastroDetalhes.numeroWcPav">
                <label>Nº WC/PAV</label>
                <input type="text" [value]="recadastroDetalhes.numeroWcPav" readonly class="campo-readonly" />
              </div>
            </div>

            <!-- COMERCIO -->
            <div class="grid-3 mb-2" *ngIf="recadastroDetalhes.tipoEconomia === 'COMERCIO'">
              <div>
                <label>Nº Salas/Lojas/Quartos</label>
                <input type="text" [value]="recadastroDetalhes.numeroDeQuartos" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Tipo Comércio</label>
                <input type="text" [value]="recadastroDetalhes.tipoComercio" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Alunos</label>
                <input type="text" [value]="recadastroDetalhes.numeroDeAlunos" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Nº Boxes</label>
                <input type="text" [value]="recadastroDetalhes.numeroDeBoxes" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Nº Banheiro</label>
                <input type="text" [value]="recadastroDetalhes.banheiros" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Área (m²)</label>
                <input type="text" [value]="recadastroDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
              </div>
            </div>

            <!-- Indústria -->
            <div class="grid-3 mb-2" *ngIf="recadastroDetalhes.tipoEconomia === 'INDUSTRIA'">
              <div>
                <label>Tipo Indústria</label>
                <input type="text" [value]="recadastroDetalhes.tipoIndustria" readonly class="campo-readonly" />
              </div>
              <div>
                <label>Área (m²)</label>
                <input type="text" [value]="recadastroDetalhes.areaMetroQuadrado" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">ESGOTO</legend>
            <div>
              <label>Tem coletor?</label>
              <input type="text" [value]="recadastroDetalhes.haColetor ? 'Sim' : 'Não'" readonly
                class="campo-readonly" />
            </div>

            <div *ngIf="recadastroDetalhes.haColetor">
              <label>Efluente encaminhado para:</label>
              <div class="grid-4 mb-2">
                <div *ngIf="recadastroDetalhes.coletor === 'true'">
                  <label>Coletor</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="recadastroDetalhes.gap === 'true'">
                  <label>GAP</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="recadastroDetalhes.rio === 'true'">
                  <label>RIO</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="recadastroDetalhes.valao === 'true'">
                  <label>VALÃO</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="recadastroDetalhes.focaFiltro === 'true'">
                  <label>Fossa/Filtro</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="recadastroDetalhes.vala === 'true'">
                  <label>Vala</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
                <div *ngIf="recadastroDetalhes.sumidouro === 'true'">
                  <label>Sumidouro</label>
                  <input type="text" value="Sim" readonly class="campo-readonly" />
                </div>
              </div>
              <div *ngIf="recadastroDetalhes.tipoValaValao">
                <label>A vala ou valão é de:</label>
                <input type="text" [value]="recadastroDetalhes.tipoValaValao" readonly class="campo-readonly" />
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">FOTOS DO LOCAL</legend>
            <div class="fotos-grid mb-2">
              <div class="foto-item" *ngFor="let foto of recadastroDetalhes.fotos">
                <div class="foto-wrapper">
                  <img [src]="getFullImageUrl(foto.url)" alt="Foto do Local" class="foto-local"
                    [ngStyle]="{'transform': 'rotate(' + getPhotoRotation(foto.url) + 'deg)'}"
                    (click)="abrirModalFoto(foto.url)" />
                  <div class="foto-actions mt-1 d-flex gap-1">
                    <a *ngIf="foto?.latitude && foto?.longitude"
                      [href]="'https://www.google.com/maps?q=' + foto.latitude + ',' + foto.longitude" target="_blank"
                      class="btn btn-outline-success btn-sm">
                      <i class="bi bi-geo-alt-fill"></i> Mapa
                    </a>
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="rotatePhoto(foto.url, -90)">
                      <i class="bi bi-arrow-counterclockwise"></i>
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="rotatePhoto(foto.url, 90)">
                      <i class="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!recadastroDetalhes.fotos?.length" class="alert alert-warning">
              Nenhuma foto disponível.
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">OUTRAS INFORMAÇÕES</legend>
            <div *ngIf="recadastroDetalhes.outrasInformacoes">
              <label>Descrição da Conclusão</label>
              <textarea readonly class="campo-readonly" rows="6">{{ recadastroDetalhes.outrasInformacoes }}</textarea>
            </div>
          </fieldset>

          <fieldset>
            <fieldset class="fotos">
              <legend class="mb-2">FOTOS DE DOCUMENTOS</legend>
              <div class="fotos-grid mb-2">
                <div class="foto-item" *ngFor="let fotoDoc of recadastroDetalhes.fotosDocumento">
                  <div class="foto-wrapper">
                    <img [src]="getFullImageUrl(fotoDoc.url)" alt="Foto do Documento" class="foto-local"
                      [ngStyle]="{'transform': 'rotate(' + getPhotoRotation(fotoDoc.url) + 'deg)'}"
                      (click)="abrirModalFoto(fotoDoc.url)" />
                    <div class="foto-actions mt-1 d-flex gap-1">
                      <a *ngIf="fotoDoc?.latitude && fotoDoc?.longitude"
                        [href]="'https://www.google.com/maps?q=' + fotoDoc.latitude + ',' + fotoDoc.longitude"
                        target="_blank" class="btn btn-outline-success btn-sm">
                        <i class="bi bi-geo-alt-fill"></i> Mapa
                      </a>
                      <button type="button" class="btn btn-outline-secondary btn-sm"
                        (click)="rotatePhoto(fotoDoc.url, -90)">
                        <i class="bi bi-arrow-counterclockwise"></i>
                      </button>
                      <button type="button" class="btn btn-outline-secondary btn-sm"
                        (click)="rotatePhoto(fotoDoc.url, 90)">
                        <i class="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="!recadastroDetalhes.fotosDocumento?.length" class="alert alert-warning">
                Nenhuma foto disponível.
              </div>
            </fieldset>

            <fieldset *ngIf="recadastroDetalhes.extraidoMemo || recadastroDetalhes.dataExtraidoMemo">
              <div class="grid-2 mb-2">
                <div *ngIf="recadastroDetalhes.extraidoMemo">
                  <label>Extraído MEMº</label>
                  <input type="text" [value]="recadastroDetalhes.extraidoMemo" readonly class="campo-readonly" />
                </div>
              </div>
            </fieldset>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Localização</legend>
            <div class="grid-2 mb-2">
              <div>
                <label>Início</label>
                <div *ngIf="recadastroDetalhes.latitudeInicio && recadastroDetalhes.longitudeInicio"
                  class="coordenadas-label">
                  <span class="badge bg-light text-dark">Lat: {{ recadastroDetalhes.latitudeInicio }} | Lng: {{
                    recadastroDetalhes.longitudeInicio }}</span>
                </div>
                <a *ngIf="recadastroDetalhes.latitudeInicio && recadastroDetalhes.longitudeInicio"
                  [href]="'https://www.google.com/maps?q=' + recadastroDetalhes.latitudeInicio + ',' + recadastroDetalhes.longitudeInicio"
                  target="_blank" class="btn btn-outline-success btn-sm ms-1">
                  <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                </a>
                <span *ngIf="!recadastroDetalhes.latitudeInicio || !recadastroDetalhes.longitudeInicio"
                  class="text-muted">Sem localização</span>
                <div class="mt-2">
                  <label>Data/Hora Início</label>
                  <input type="text" [value]="recadastroDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm:ss'" readonly
                    class="campo-readonly" />
                </div>
              </div>
              <div>
                <label>Fim</label>
                <div *ngIf="recadastroDetalhes.latitudeFim && recadastroDetalhes.longitudeFim"
                  class="coordenadas-label">
                  <span class="badge bg-light text-dark">Lat: {{ recadastroDetalhes.latitudeFim }} | Lng: {{
                    recadastroDetalhes.longitudeFim }}</span>
                </div>
                <a *ngIf="recadastroDetalhes.latitudeFim && recadastroDetalhes.longitudeFim"
                  [href]="'https://www.google.com/maps?q=' + recadastroDetalhes.latitudeFim + ',' + recadastroDetalhes.longitudeFim"
                  target="_blank" class="btn btn-outline-danger btn-sm ms-1">
                  <i class="bi bi-geo-alt-fill"></i> Ver no mapa
                </a>
                <span *ngIf="!recadastroDetalhes.latitudeFim || !recadastroDetalhes.longitudeFim" class="text-muted">Sem
                  localização</span>
                <div class="mt-2">
                  <label>Data/Hora Fim</label>
                  <input type="text" [value]="recadastroDetalhes.dataHoraFim | date:'dd/MM/yyyy HH:mm:ss'" readonly
                    class="campo-readonly" />
                </div>
              </div>
            </div>
            <div class="map-container">
              <div id="map-recadastro"></div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Dados do Acompanhante</legend>
            <div class="grid-3 mb-2">
              <div>
                <label>Nome do Acompanhante</label>
                <input type="text" [value]="recadastroDetalhes.nomeAcompanhante || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>CPF do Acompanhante</label>
                <input type="text" [value]="maskCpf(recadastroDetalhes.cpfAcompanhante)" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Telefone do Acompanhante</label>
                <input type="text" [value]="maskTelefone(recadastroDetalhes.telefoneAcompanhante)" readonly
                  class="campo-readonly" />
              </div>
            </div>
            <div class="grid-1 mb-2">
              <div *ngIf="recadastroDetalhes.assinaturaAcompanhante?.url">
                <label>Assinatura do Acompanhante</label>
                <div class="signature-image" (click)="abrirModalFoto(recadastroDetalhes.assinaturaAcompanhante.url)">
                  <img [src]="getFullImageUrl(recadastroDetalhes.assinaturaAcompanhante.url)"
                    alt="Assinatura do Acompanhante">
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset>
            <legend class="mb-2">Dados do Vistoriador</legend>
            <div class="grid-2 mb-2">
              <div>
                <label>Nome do Vistoriador</label>
                <input type="text" [value]="recadastroDetalhes.nomeVistoriante || '-'" readonly
                  class="campo-readonly" />
              </div>
              <div>
                <label>Data da Vistoria</label>
                <input type="text" [value]="recadastroDetalhes.dataHoraInicio | date:'dd/MM/yyyy HH:mm'" readonly
                  class="campo-readonly" />
              </div>
            </div>
            <div class="grid-1 vistoriador-foto mb-2">
              <div
                *ngIf="recadastroDetalhes.fotoVistoriante && recadastroDetalhes.fotoVistoriante !== 'URL_PADRAO_SEM_IMAGEM'">
                <label>Foto do Vistoriador</label>
                <div class="foto-vistoriador" (click)="abrirModalFoto(recadastroDetalhes.fotoVistoriante)">
                  <img [src]="getFullImageUrl(recadastroDetalhes.fotoVistoriante)" alt="Foto do Vistoriador"
                    class="foto-vistoriador">
                </div>
              </div>
              <div
                *ngIf="!recadastroDetalhes.fotoVistoriante || recadastroDetalhes.fotoVistoriante === 'URL_PADRAO_SEM_IMAGEM'"
                class="alert alert-warning">
                Foto não disponível
              </div>
            </div>
            <div class="grid-1 mb-2">
              <div *ngIf="recadastroDetalhes.assinaturaVistoriante?.url">
                <label>Assinatura do Vistoriador</label>
                <div class="signature-image" (click)="abrirModalFoto(recadastroDetalhes.assinaturaVistoriante.url)">
                  <img [src]="getFullImageUrl(recadastroDetalhes.assinaturaVistoriante.url)"
                    alt="Assinatura do Vistoriador">
                </div>
              </div>
              <span *ngIf="!recadastroDetalhes.assinaturaVistoriante?.url" class="text-muted">Sem assinatura</span>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger me-2" (click)="exportarRecadastroParaPDF()">
          <i class="bi bi-file-earmark-pdf-fill me-1"></i> Exportar PDF
        </button>
        <button type="button" class="btn btn-secondary" (click)="fecharModalDetalhes()">Fechar</button>
      </div>
    </div>
    <div *ngIf="recadastroDetalhes?.analisadoPorNome && recadastroDetalhes?.status === 'Validado'"
      class="d-flex justify-content-end mt-4">
      <span class="badge bg-gradient-info"
        style="font-size: 1.1rem; padding: 12px 28px; border-radius: 18px; box-shadow: 0 2px 8px rgba(0,0,0,0.08); letter-spacing: 1px; font-weight: 700; display: flex; flex-direction: column; align-items: flex-start;">
        <span><i class="bi bi-person-check-fill me-2"></i> Analisado por: {{ recadastroDetalhes.analisadoPorNome
          }}</span>
        <span *ngIf="recadastroDetalhes.dataHoraInicioAnalise"
          style="font-size: 0.95rem; font-weight: 500; margin-top: 2px;">
          <i class="bi bi-calendar-check me-1"></i>
          Data da análise: {{ recadastroDetalhes.dataHoraInicioAnalise | date: 'dd/MM/yyyy HH:mm' }}
        </span>
      </span>
    </div>
  </div>
</div>

<!-- Modal de visualização de foto ampliada -->
<div class="modal-foto" [class.show]="mostrarModalFoto" *ngIf="mostrarModalFoto" (click)="fecharModalFoto()">
  <div class="modal-foto-content" (click)="$event.stopPropagation()">
    <button type="button" class="btn-close-foto" (click)="fecharModalFoto()">
      <i class="fas fa-times"></i>
    </button>
    <img [src]="getFullImageUrl(fotoSelecionada)" alt="Foto Ampliada" class="foto-ampliada">
  </div>
</div>

<!-- Container oculto para exportação completa -->
<div #conteudoCompleto style="position: absolute; top: -9999px; left: -9999px; width: 1000px;">
  <div [innerHTML]="htmlCompletoParaExportar"></div>
</div>